import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";

function ResidenciesDetailsTab(props) {

    const [isOpen, setOpen] = useState(false);

    return (
        <>
            <div className="package-details-tabs">
                <ul
                    className="nav nav-pills tab-switchers gap-xxl-4 gap-3"
                    id="pills-tab"
                    role="tablist"
                >
                    <li className="nav-item" role="presentation">
                        <button
                            className="nav-link active"
                            id="pills-package1"
                            data-bs-toggle="pill"
                            data-bs-target="#pill-body1"
                            type="button"
                            role="tab"
                            aria-controls="pill-body1"
                            aria-selected="true"
                        >
                            <i className="fa-solid fa-circle-info"></i> Residency info
                        </button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button
                            className="nav-link"
                            id="pills-package2"
                            data-bs-toggle="pill"
                            data-bs-target="#pill-body2"
                            type="button"
                            role="tab"
                            aria-controls="pill-body2"
                            aria-selected="false"
                        >
                            <i className="fa-solid fa-bag-shopping"></i> How to book
                        </button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button
                            className="nav-link"
                            id="pills-package3"
                            data-bs-toggle="pill"
                            data-bs-target="#pill-body3"
                            type="button"
                            role="tab"
                            aria-controls="pill-body3"
                            aria-selected="false"
                        >
                            <i className="fa-solid fa-location-dot"></i> Where & when
                        </button>
                    </li>

                </ul>
                <div className="tab-content" id="pills-tabContent">

                    {/* info tab */}
                    <div
                        className="tab-pane fade show active package-info-tab"
                        id="pill-body1"
                        role="tabpanel"
                        aria-labelledby="pills-package1"
                    >
                        <h3 className="d-subtitle">A place to <span className="txt-gradient-1">think</span> / <span className="txt-gradient-2">work</span> / <span className="txt-gradient-3">create</span> / <span className="txt-gradient-4">live</span></h3>
                        <div className="workshop_bodytext">
                            <p>This year, for the first time ever, we're making CAMP available for <strong>self-directed residencies</strong> at the start and end of the season. Choose to stay at CAMP for anything from one to six weeks, fully catered, in your own private room, and with full access to our facilities. Explore the mountains, forests and lakes, take time out from your daily life, and dedicate some time to think, write, and create.</p>

                            <p>In terms of facilities, we have indoor and outdoor work and performance spaces, sound systems, projectors, music production gear (interfaces, speakers, mics, controllers), computers, acoustic and electronic instruments, a beautiful Yamaha U10 piano, drum kit, loads of AV equipment, VR gear, field recording equipment (recorders, mics, etc), art/making equipment (glue guns, soldering irons, hand-tools, etc), and a lot more.</p>

                            <p>You'll have <strong>full access</strong> day and night to all facilities, including the CAMP library, a treasure trove of important and super-niche publications, recordings and films.</p>

                            <p>We can cater for all diets, and there's always plenty of wine, cheese and snacks flowing! A few things previous attendees have said about the food at CAMP:</p>

                            <i><p>So tasty and delicious, lots of new recipes to take home and try and also a check in about how badly I was eating prior!</p>

                                <p>Banging. Delicious food, plenty of it and lots of wine too, which is nice!</p>

                                <p>As a vegetarian, it was awesome. Fresh and delicious food cooked by the lovely staff everyday. Cherry on top: fresh croissants, beers and cheese everyday <i className="fa-solid fa-heart"></i> You guys rock.</p>

                                <p>Honestly one of the highlights. Utterly delicious.</p></i>
                        </div>

                    </div>


                    {/* how to book tab */}
                    <div
                        className="tab-pane fade package-plan-tab"
                        id="pill-body2"
                        role="tabpanel"
                        aria-labelledby="pills-package2"
                    >
                        <h3 className="d-subtitle">How to book</h3>
                        <div className="workshop_bodytext">
                            <p>To book a residency slot, just select the weeks you want in the form on this page, then choose either to pay for your residency in full or set up a 4-month payment plan. Once you're booked in, you will be able to complete a full artist profile on the CAMP Hub, allowing us to check out your work, understand what you do, and ensure that you get the most out of your stay.</p>

                            <p>We've made the residencies as cheap as possible - for a 1 month stay it works out around €45 per day (that's for full-board, including all food, drinks, infinite wine, snacks etc).</p>

                            <table className="table residency_price_table">
                                <tbody>
                                    <tr>
                                        <th>Residency length</th>
                                        <th>Price</th>
                                    </tr>
                                    <tr>
                                        <td>1 week</td>
                                        <td>€399</td>
                                    </tr>
                                    <tr>
                                        <td>2 weeks</td>
                                        <td>€759</td>
                                    </tr>
                                    <tr>
                                        <td>3 weeks</td>
                                        <td>€1,079</td>
                                    </tr>
                                    <tr>
                                        <td>4 weeks</td>
                                        <td>€1,399</td>
                                    </tr>
                                    <tr>
                                        <td>5 weeks</td>
                                        <td>€1,699</td>
                                    </tr>
                                    <tr>
                                        <td>6 weeks</td>
                                        <td>€1,979</td>
                                    </tr>
                                </tbody>
                            </table>

                            <p>All card payments are handled by Stripe, and are <strong>extremely secure</strong>. We don't store any card data ourselves - all of this is handled securely off-site by Stripe. Once you've made a payment, you'll receive another email containing your receipt, links to resources, contact information and a CAMP Hub account, which you can use to get more info on your residency.</p>
                        </div>
                    </div>

                    {/* where and when */}
                    <div
                        className="tab-pane fade package-where-tab"
                        id="pill-body3"
                        role="tabpanel"
                        aria-labelledby="pills-package3"
                    >

                        <h3 className="d-subtitle">Where & when</h3>
                        <div className="workshop_bodytext">
                            <p>Residencies take place at our arts facility in Aulus les Bains. It's two hours south of Toulouse, high in the French Pyrenees, very near the border with Spain. For detailed travel information, see the transport section. We're running residencies in April, May, June and November - it's up to you how long you spend here, you can stay as little as one week, or as long as six weeks.</p>
                            <p>In terms of weather, it's always difficult to predict this alpine environment, but in general: April is bright and sunny but can be slightly chilly, with average daytime temperatures around 15°C. There will usually still be snow on the mountains. This is a great time to visit to witness the alpine landscape come to life after the winter, and a particularly peaceful period with very few tourists at this time of year.</p>
                            <p>In May, things start to get very summery, with the average daily temperature rising to around 18°C, and hot sunshine most days. Snow is mostly gone from the high plateaus, with some remaining on the higher ridges and north faces.</p> 
                            <p>By June, Aulus is approaching full summer, with daily temperatures reaching 23°C - 29°C. </p>
                            <p>At the other end of the season, the temperatures and weather in November are very similar to April (average 15°C. in the day), and there's a chance of the first snowfall of the season on the high ridges. This is the quietest time in the village - only locals remain - it's the best time of year to visit if you want the mountains to yourself.</p>
                        </div>


                    </div>

                </div>
            </div>
        </>
    );
}

export default ResidenciesDetailsTab;
